"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorIconWithTooltip = void 0;
var Error_1 = require("@mui/icons-material/Error");
var React = require("react");
var IconWithTooltip_1 = require("./IconWithTooltip");
var style = {
    color: '#c00000',
    display: 'inline-block',
};
var ErrorIconWithTooltip = function (_a) {
    var placement = _a.placement, text = _a.text;
    return (React.createElement("div", { style: style },
        React.createElement(IconWithTooltip_1.default, { Icon: Error_1.default, text: text, placement: placement })));
};
exports.ErrorIconWithTooltip = ErrorIconWithTooltip;
//# sourceMappingURL=ErrorIconWithTooltip.js.map